export default __webpack_public_path__ + "static/media/img_6.4ff6f726.JPG";